import * as colors from '../constants/colors'

export function hexToRgb(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return `rgba(${r},${g},${b},${alpha})`
  } else {
    return `rgb(${r},${g},${b})`
  }
}

export function rgbaToHexA(rgba: string | undefined, forceRemoveAlpha = false) {
  if (!rgba) {
    return undefined
  }

  return (
    '#' +
    rgba
      .replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
      .split(',') // splits them at ","
      .filter((string, index) => !forceRemoveAlpha || index !== 3)
      .map((string) => parseFloat(string)) // Converts them to numbers
      .map((number, index) => (index === 3 ? Math.round(number * 255) : number)) // Converts alpha to 255 number
      .map((number) => number.toString(16)) // Converts numbers to hex
      .map((string) => (string.length === 1 ? '0' + string : string)) // Adds 0 when length of one number is 1
      .join('')
  ) // Puts the array together to a string
}

/**
 * LEGACY UTILS
 **/

const PRIMARY_COLORS = {
  'primary-black': colors.PRIMARY_GREY_900,
  'primary-blue': colors.PRIMARY_BLUE_500,
  'primary-red': colors.PRIMARY_RED_500,
  'primary-white': colors.PRIMARY_GREY_000,
  'primary-green': colors.SECONDARY_GREEN_500,
}

/** @deprecated STOP. Do NOT use on new code, NEVER. */
export const primary = (props: any) => {
  const primaryColor = props.theme && props.theme.colors && props.theme.colors.primary
  if (primaryColor && primaryColor.charAt(0) === '#') {
    return primaryColor
  }

  // @ts-expect-error This is legacy code only kept here because it is used on old view with no TS, let's not overengineer.
  if (PRIMARY_COLORS[primaryColor]) {
    // @ts-expect-error This is legacy code only kept here because it is used on old view with no TS, let's not overengineer.
    return PRIMARY_COLORS[primaryColor]
  }

  return colors.PRIMARY_BLUE_500
}

const PRIMARY_HOVER = {
  'primary-black': colors.PRIMARY_GREY_700,
  'primary-blue': colors.PRIMARY_BLUE_500,
  'primary-red': colors.PRIMARY_RED_700,
  // HACK: Was not replaced with a proper replacement during legacy colors deletion (was #64D088 before that).
  //  If you're seeing weird results, please reach out to Product to see if we shouldn't reintroduce #64D088 as a legacy token.
  'primary-green': colors.SECONDARY_GREEN_800,
}

const PRIMARY_HOVER_HEX = {
  [colors.PRIMARY_GREY_900.toLowerCase()]: colors.PRIMARY_GREY_700,
  [colors.PRIMARY_BLUE_500.toLowerCase()]: colors.PRIMARY_BLUE_700,
  [colors.PRIMARY_RED_500.toLowerCase()]: colors.PRIMARY_RED_700,
  // HACK: Was not replaced with a proper replacement during legacy colors deletion (was #64D088 before that).
  //  If you're seeing weird results, please reach out to Product to see if we shouldn't reintroduce #64D088 as a legacy token.
  [colors.SECONDARY_GREEN_500.toLowerCase()]: colors.SECONDARY_GREEN_800,
}

/** @deprecated STOP. Do NOT use on new code, NEVER. */
export const primaryHover = (props: any) => {
  const color = props.theme && props.theme.colors && props.theme.colors.primary

  if (!color) {
    return colors.PRIMARY_BLUE_700
  }

  // @ts-expect-error This is legacy code only kept here because it is used on old view with no TS, let's not overengineer.
  if (PRIMARY_HOVER[color]) {
    // @ts-expect-error This is legacy code only kept here because it is used on old view with no TS, let's not overengineer.
    return PRIMARY_HOVER[color]
  }

  const lowerCaseColor = color.toLowerCase()
  if (lowerCaseColor && lowerCaseColor.charAt(0) === '#') {
    if (PRIMARY_HOVER_HEX[lowerCaseColor]) {
      return PRIMARY_HOVER_HEX[lowerCaseColor]
    }

    return hexToRgb(lowerCaseColor, 0.85)
  }

  return colors.PRIMARY_BLUE_700
}
